import Swiper, { Pagination, Navigation, Autoplay } from 'swiper/core';
Swiper.use([Pagination, Navigation, Autoplay]);

import dataLayerLogic from "./dataLayerLogic";
export default function () {

    let sliders = document.querySelectorAll('.hero-slider .swiper-container')
    sliders.forEach((slider)=> {

        let hero = new Swiper(slider, {
            direction: 'horizontal',
            loop: true,
            pagination: {
                el: '.hero-slider .swiper-pagination',
                clickable: true
            },
            speed: 1000,

            navigation: {
                nextEl: '.hero-slider .swiper-button-next',
                prevEl: '.hero-slider .swiper-button-prev',
            },

            scrollbar: {
                el: '.hero-slider .swiper-scrollbar',
            },
        });

        if (hero.$el.attr('data-timer') !== '0') {
            hero.autoplay.start()
        }
    })

    const smallGeneralSliders = document.querySelectorAll('.small-general-slider .swiper');
    smallGeneralSliders.forEach((slider) => {
        const sliderContainer = slider.parentElement;
        const sliderContainerSelector = '.' + Array.from(sliderContainer.classList).join('.')

        let smallGeneralSlider = new Swiper(slider, {
            uniqueNavElements: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            slidesPerGroupSkip: 0,
            spaceBetween: 24,
            loop: true,

            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                992: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },

            pagination: {
                el: '.small-general-slider .swiper-pagination',
                clickable: true
            },
            speed: 1000,

            navigation: {
                nextEl: sliderContainerSelector + ' .swiper-button-next',
                prevEl: sliderContainerSelector + ' .swiper-button-prev',
            },
        });

        if (smallGeneralSlider.$el.attr('data-timer') !== '0') {
            smallGeneralSlider.autoplay.start()
        }
    });

    const smallContentSliders = document.querySelectorAll('.small-content-slider .swiper');
    smallContentSliders.forEach((slider) => {
        const sliderContainer = slider.parentElement;
        const sliderContainerSelector = '.' + Array.from(sliderContainer.classList).join('.')

        let smallContentSlider = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,

            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 4,
                }
            },

            speed: 1000,

            navigation: {
                nextEl: sliderContainerSelector + ' .swiper-button-next',
                prevEl: sliderContainerSelector + ' .swiper-button-prev',
            },
        });

        if (smallContentSlider.$el.attr('data-timer') !== '0') {
            smallContentSlider.autoplay.start()
        }
    });

    const allYtPopups = jQuery('.small-content-slider__slide-anchor[data-popup-type="yt"]');
    const allFilePopups = jQuery('.small-content-slider__slide-anchor[data-popup-type="file"]');

    if (allYtPopups.length) {
        allYtPopups.modaal({
            type: 'video',
            before_open: function (event) {
            },
            after_open: function (modalWrapper) {
                const $iframeElement = jQuery(modalWrapper).find('iframe');

                if (!$iframeElement.length) {
                    return;
                }

                dataLayerLogic.loadYouTubeAPI();
                dataLayerLogic.initializeYouTubePlayer($iframeElement[0]);
            },
        });
    }

    if (allFilePopups.length) {
        allFilePopups.modaal({
            custom_class: 'small-content-slider__popup-file',
            before_close: function (modal_wrapper) {
                const videoElement = modal_wrapper.find('video').get(0);
                videoElement.pause();
            }
        });
    }
}
